class HotspotComponent extends HTMLElement {
  constructor() {
    super();
    this.slides = Array.from(this.querySelectorAll('[data-hotspot-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-hotspot-dot]'));
    this.panels = Array.from(this.querySelectorAll('[data-hotspot-product]'));
    this.prevButtons = Array.from(this.querySelectorAll('[data-hotspot-prev]'));
    this.nextButtons = Array.from(this.querySelectorAll('[data-hotspot-next]'));

    this.dots.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        this.setActiveProduct(dot.dataset.hotspotDot);
      });
    });

    this.prevButtons.forEach((button) => button.addEventListener('click', () => this.stepLook(-1)));
    this.nextButtons.forEach((button) => button.addEventListener('click', () => this.stepLook(1)));

    this.addEventListener('shopify:block:select', (event) => {
      const index = event.target.dataset.hotspotSlide;
      if (index !== undefined) this.setActiveLook(index);
    });
  }

  setActiveLook(lookIndex) {
    const value = String(lookIndex);

    this.slides.forEach((slide) => {
      slide.classList.toggle('is-active', slide.dataset.hotspotSlide === value);
    });

    const firstDotInLook = this.dots.find((dot) => dot.dataset.hotspotLook === value);
    if (firstDotInLook) this.setActiveProduct(firstDotInLook.dataset.hotspotDot);
  }

  setActiveProduct(index) {
    const value = String(index);

    this.dots.forEach((dot) => {
      dot.classList.toggle('is-active', dot.dataset.hotspotDot === value);
      dot.setAttribute('aria-pressed', dot.dataset.hotspotDot === value);
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.dataset.hotspotProduct === value);
    });
  }

  stepLook(direction) {
    if (this.slides.length < 2) return;
    const currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
    const nextIndex = (currentIndex + direction + this.slides.length) % this.slides.length;
    this.setActiveLook(this.slides[nextIndex].dataset.hotspotSlide);
  }
}

customElements.define('hotspot-component', HotspotComponent);
